// Displays top 3 real market prices from UAE retailers (Gemini grounded).
// Tap a row to auto-fill the price input. External link opens the retailer.
import { ExternalLink, TrendingDown } from "lucide-react";

const MEDAL = ["\ud83e\udd47", "\ud83e\udd48", "\ud83e\udd49"];

export function PriceComparison({ market, onPick, ar }) {
  if (!market?.prices?.length) return null;
  const top3 = market.prices.slice(0, 3);
  const q = encodeURIComponent(market.product || "");
  const googleUrl = `https://www.google.com/search?tbm=shop&q=${q}+UAE+price`;
  return (
    <div className="space-y-1.5" data-testid="price-comparison">
      <p className="text-[11px] font-bold text-emerald-700 flex items-center gap-1">
        <TrendingDown className="w-3 h-3" />
        {ar ? "أفضل الأسعار في الإمارات (مباشر)" : "Best UAE prices (live)"}
      </p>
      {top3.map((p, i) => (
        <button key={i} type="button" onClick={() => onPick(p.price)}
          data-testid={`price-option-${i}`}
          className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-xl neu-inset hover:bg-emerald-50 transition-colors text-start">
          <span className="flex items-center gap-2 text-sm font-semibold min-w-0">
            <span className="text-base shrink-0">{MEDAL[i]}</span>
            <span className="truncate">{p.store}</span>
          </span>
          <span className="flex items-center gap-1.5 shrink-0">
            <span className="text-sm font-bold tabular-nums text-emerald-700">
              {Number(p.price).toFixed(2)} {market.currency}
            </span>
            {p.url && (
              <a href={p.url} target="_blank" rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="text-slate-400 hover:text-blue-600" aria-label="open">
                <ExternalLink className="w-3.5 h-3.5" />
              </a>
            )}
          </span>
        </button>
      ))}
      <a href={googleUrl} target="_blank" rel="noreferrer"
        data-testid="view-all-google"
        className="text-[10px] text-blue-600 hover:underline flex items-center gap-1 justify-center pt-0.5">
        {ar ? "عرض الكل في Google" : "View all on Google"} <ExternalLink className="w-2.5 h-2.5" />
      </a>
    </div>
  );
}
